module.exports = __webpack_public_path__ + "img/cuponIcon.9ff98bac.svg";